// extracted by mini-css-extract-plugin
module.exports = {"photoswipeGallery":"photoswipe-gallery-view_photoswipeGallery__3bNmc","list":"photoswipe-gallery-view_list__fQEsc","item":"photoswipe-gallery-view_item__3OtIZ"};